const noop = () => { };
// tslint:disable-next-line:ban-types
export default function isRequired(requiredType?: 'string' | 'boolean' | 'number'): Function {
    return (target: any, prop: string) => {
        const NG_ON_ONIT_NAME = 'ngOnInit';
        // tslint:disable-next-line:ban-types
        const ngOnInitClone: Function | null = target[NG_ON_ONIT_NAME];
        Object.defineProperty(target, NG_ON_ONIT_NAME, {
            value(): void {
                if (this[prop] == null) {
                    console.error(target.constructor.name + `: "${prop}" is required, but was not provided`);
                } else if ( requiredType && typeof this[prop] !== requiredType ) {
                    // tslint:disable-next-line:max-line-length
                    console.error(target.constructor.name + `: "${prop}" is expected to be a "${requiredType}", but "${typeof this[prop]}" was provided`);
                }
                (ngOnInitClone || noop).call(this);
            }
        });
    };
}
